(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-lgip-form]');
    const add = form?.querySelector('[data-lg-add]');
    const update = () => {
      const option = form.querySelector('input[name="id"]:checked');
      if (!option || form.dataset.eligible !== 'true') return;
      root.querySelector('[data-lgip-price]').textContent = option.dataset.price;
      if (add) {
        const enabled = option.dataset.available === 'true';
        add.setAttribute('aria-disabled', String(!enabled));
        add.disabled = !enabled || document.querySelector('[data-lg-quick-cart]')?.getAttribute('aria-busy') === 'true';
        add.innerHTML = `${enabled ? 'Add to bag' : 'Sold out'}<span aria-hidden="true">↗</span>`;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState(null, '', url);
    };
    form?.addEventListener('change', event => { if(event.target.name === 'id') update(); });
    form?.addEventListener('submit', event => {
      const selected = form.querySelector('input[name="id"]:checked');
      if (form.dataset.eligible !== 'true' || selected?.dataset.available !== 'true') event.preventDefault();
    });
    root.querySelectorAll('[data-lgip-step]').forEach(button => button.addEventListener('click', () => {
      const input = form.querySelector('input[name="quantity"]');
      if (Number(button.dataset.lgipStep) > 0) input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('change', {bubbles:true}));
    }));
    const main = root.querySelector('[data-lgip-main]');
    const stage = root.querySelector('[data-lgip-stage]');
    const thumbs = root.querySelector('.lgip-thumbs');
    const angleGallery = thumbs?.dataset.lgipAngleGallery === 'true';
    const showImage = button => {
      if (!main || !button) return;
      const responsiveSet = button.dataset.srcset;
      if (responsiveSet) {
        main.setAttribute('srcset', responsiveSet);
        main.setAttribute('sizes', button.dataset.sizes || '100vw');
      } else {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
      }
      main.src = button.dataset.src;
      main.alt = button.dataset.alt;
      main.dataset.alpha = button.dataset.alpha || 'false';
      main.style.setProperty('--angle-scale', button.dataset.angleScale || '1');
      main.style.mixBlendMode = 'normal';
      thumbs.querySelectorAll('[data-lgip-thumbnail]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      stage.classList.toggle('is-product-view', button.dataset.view !== 'scene');
      stage.classList.toggle('is-detail-view', button.dataset.view === 'detail');
    };
    thumbs?.addEventListener('click', event => {
      const button = event.target.closest('[data-lgip-thumbnail]');
      if (button && thumbs.contains(button)) showImage(button);
    });
    const colors = [...root.querySelectorAll('[data-lgip-color]')];
    const selectColor = (option, updateUrl = true) => {
      if (!thumbs || !main) return;
      const template = angleGallery ? null : [...root.querySelectorAll('template[data-lgip-color-gallery]')].find(item => item.dataset.lgipColorGallery === option.dataset.handle);
      if (!angleGallery && !template) return;
      option.checked = true;
      root.querySelector('[data-lgip-color-name]').textContent = option.value;
      form.querySelector('[data-lgip-color-handle]').value = option.dataset.handle;
      if (!angleGallery) {
        stage.dataset.alpha = option.dataset.alpha;
        thumbs.replaceChildren(template.content.cloneNode(true));
        showImage(thumbs.querySelector('[data-lgip-thumbnail]'));
      }
      const specImage = root.querySelector('[data-lgip-spec-image]');
      if (specImage) {specImage.src = option.dataset.image; specImage.alt = option.dataset.alt; specImage.dataset.alpha = option.dataset.alpha;}
      if (updateUrl) {const url = new URL(location.href);url.searchParams.set('color',option.dataset.handle);history.replaceState(null,'',url);}
    };
    colors.forEach(option => option.addEventListener('change', () => {if(option.checked) selectColor(option);}));
    const requestedColor = colors.find(option => option.dataset.handle === new URL(location.href).searchParams.get('color'));
    if (requestedColor) selectColor(requestedColor, false);
    const dialog = root.querySelector('[data-lgip-lightbox]');
    root.querySelector('[data-lgip-zoom]')?.addEventListener('click', () => {
      if (!main || typeof dialog.showModal !== 'function') return;
      const image = dialog.querySelector('img'); image.src=main.src;image.alt=main.alt;dialog.showModal();
    });
    root.querySelector('[data-lgip-close]')?.addEventListener('click',()=>dialog.close());
    dialog?.addEventListener('click',event=>{ if(event.target === dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();} });
  };
  document.querySelectorAll('[data-lgip]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-lgip]').forEach(init));
})();
